import createCollectionResource from 'src/actions/shared/createResource';
import { AppThunk } from 'src/actions/shared/sharedTypes';
import { DomainError as StandardDomainError, Unauthorized } from '@ad-scripts/application/lib/error';
import { logout } from 'src/actions/auth/authSlice';
import { translateErrors } from 'src/adapters/validateType';
import emptyObserverCreator from '../shared/emptyObserverCreator';

export enum PhoneNumberType {
  LOCAL = 'LOCAL',
  TOLL_FREE = 'TOLL_FREE',
}

export enum PhoneNumberCapability {
  MMS = 'MMS',
  SMS = 'SMS',
  VOICE = 'VOICE',
}

export type AvailablePhoneNumber = {
  accountId?: string;
  capabilities: PhoneNumberCapability[];
  countryCode: string;
  id: string;
  locality: string;
  phoneNumber: string;
  phoneNumberType: PhoneNumberType;
  region: string;
};

type availableNumbersQuery = {
  phoneNumberType: string;
  capabilities?: string[];
  countryCode: string;
  areaCode?: string;
  locality?: string;
  contains?: string;
};

const availableNumbersResource = createCollectionResource<AvailablePhoneNumber>({
  name: 'availableNumbers',
  endpoint: 'v1/orgs/:orgId/available-numbers',
  observerCreator: emptyObserverCreator,
});

const { fetchStarted, fetchSuccess, fetchError, fetchRequestError } = availableNumbersResource.actions;

const fetchAll: AppThunk =
  searchForm =>
  async (dispatch, _, { gateways }) => {
    const { numberType, capabilities, countryCode, filterType, searchTerm } = searchForm;

    const searchQuery: availableNumbersQuery = {
      phoneNumberType: numberType,
      capabilities: capabilities,
      countryCode: countryCode,
    };

    switch (filterType) {
      case 'AREA_CODE':
        searchQuery.areaCode = searchTerm;
        break;
      case 'LOCALITY':
        searchQuery.locality = searchTerm;
        break;
      case 'CONTAINS':
        searchQuery.contains = searchTerm;
        break;
    }

    try {
      dispatch(fetchStarted({}));
      const result = await gateways.availableNumbers.get({ params: searchQuery });
      dispatch(fetchSuccess(result));
    } catch (err) {
      if (err instanceof StandardDomainError) {
        dispatch(fetchError(translateErrors(err.errors)));
      } else if (err instanceof Unauthorized) {
        dispatch(logout());
      } else {
        dispatch(fetchRequestError({}));
      }
    }
  };

availableNumbersResource.effects.fetchAll = fetchAll;

export default availableNumbersResource;
